/**
 * shim implementation taken from https://developers.google.com/web/updates/2015/08/using-requestidlecallback
 */
const requestIdleFallback = (
  cb: (deadline: RequestIdleCallbackDeadline) => void
) => {
  const start = Date.now();
  return window.setTimeout(() => {
    // eslint-disable-next-line n/no-callback-literal
    cb({
      didTimeout: false,
      timeRemaining: () => {
        return Math.max(0, 50 - (Date.now() - start));
      },
    });
  }, 1);
};

export const doAsync = (
  callback: (deadline: RequestIdleCallbackDeadline) => void
): RequestIdleCallbackHandle => {
  if ('requestIdleCallback' in window) {
    return window.requestIdleCallback!(callback);
  } else {
    return requestIdleFallback(callback);
  }
};
